var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBreadcrumbHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8453 16H12.6685C12.144 16 11.719 15.5598 11.719 15.017V12.2181C11.719 12.1433 11.6604 12.0827 11.5882 12.0827H8.40703C8.33487 12.0827 8.27626 12.1433 8.27626 12.2181V15.017C8.27626 15.56 7.85105 16 7.32674 16H5.15473C4.51691 16 4 15.4647 4 14.8046V8.97414C4 8.44867 4.24499 7.95017 4.65525 7.64061L9.06157 4.31744C9.62283 3.89419 10.377 3.89419 10.9383 4.31744L15.3448 7.64061C15.755 7.94999 16 8.44849 16 8.97414V14.8046C16 15.4649 15.4829 16 14.8453 16Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBreadcrumbHome);
export default __webpack_public_path__ + "static/media/icon_breadcrumb_home.120598330956f832f28518ce42d7b8b9.svg";
export { ForwardRef as ReactComponent };